var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.shouldShowConnectionBanner ? _c("ConnectionBanner") : _vm._e(),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container max-app-width" },
        [
          _c("ProgressBar"),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c("ReviewCard", { staticClass: "d-md-none d-lg-none d-xl-none" })
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }